module.exports = __webpack_public_path__ + "img/new-edit.2d30c5f1.png";